/*
 * � 2020 Microsoft. All rights reserved.
 */

define('util/Random',[], function () {
    "use strict";

    var Random = function (seed) {
        this.initRandom(seed);
    };

    Random.prototype.initRandom = function (seed) {
        this._seed = seed;
    };

    Random.prototype.Next = function (low, high) {
        if (!high) {
            high = low;
            low = 0;
        }
        return (low + Math.floor(Math.random() * (high - low)));
    };

    return Random;
});
